/** Profile navigates to /team with this flag so the walkthrough runs after load. */
export const STORAGE_PENDING_TEAM_MANUAL = 'akoreps_pendingManualTeamDashboardTour';
